export default __webpack_public_path__ + "static/media/Q2-3.3b8460ce.png";